import React from "react";
import ReactDOM from 'react-dom/client';
import App from "./App";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// Import global styles
import './styles/theme-variables.css';
import './styles/components.css';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

serviceWorkerRegistration.unregister();
